import { render } from "./GoodCategoriesList.vue?vue&type=template&id=4eaee3c3"
import script from "./GoodCategoriesList.vue?vue&type=script&lang=js"
export * from "./GoodCategoriesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__